// @flow
import React from 'react';
import type { ProductItem } from 'store/modules/display';
import './SaveProductCardList.scss';
import SaveProductCard from '../SaveProductCard';

type Props = {
  products: ?(ProductItem[]),
  onAskRemove: (productId: string) => void,
};

const SaveProductCardList = ({ products, onAskRemove }: Props) => {
  if (!products) return null;
  const productList = products.map(product => (
    <SaveProductCard
      key={product.id}
      id={product.id}
      title={product.title}
      thumbnail={product.thumbnail}
      updatedAt={product.updated_at}
      onAskRemove={onAskRemove}
    />
  ));
  return <div className="SaveProductCardList">{productList}</div>;
};

export default SaveProductCardList;



// WEBPACK FOOTER //
// ./src/components/saves/SaveProductCardList/SaveProductCardList.js